import React from "react";
import ReactHtmlParser from "react-html-parser";

export class ProductDescription extends React.Component<any, any> {
	constructor(props:any) {
		super(props);
		this.state = {showMore: false};
	}

	handleShowMore = () => {
		this.setState( (prevState:any) =>({
			showMore: !prevState.showMore
		}));
	}

	render(): React.ReactNode {
		var div_id = "product_desc_" + this.props.product_id;

		var _more_text       = "READ MORE";
		var _less_text       = "SHOW LESS";
		var _span_margin	 = "5px";

		var has_show_more = this.props.post_excerpt.length > 140;
		var _desc_long_txt = this.props.post_excerpt.length > 0 ? this.props.post_excerpt : '';
		var _desc_short_txt= this.props.post_excerpt.length > 0 ? (this.props.post_excerpt.substring(0, 140) + "<span style='margin-left:5px'>...</span>") : '';

		return (
			<div id={div_id} className="vm_productlist_descriptiontext_inner">
				{ this.props.hours > 0 ?
					<p style={{width:"100%", margin:"0", padding: "0", fontSize: "13px", minHeight: "13px", float: "left"}}><b>{this.props.hours}</b></p>
					: null
				}
				<p style={{ width:"100%", margin:"0", padding:"0", fontSize:"13px", minHeight: "72px", float: "left"}}>
					<>
						{ has_show_more ?
							<>
								{ this.state.showMore ?
									<>{ReactHtmlParser(_desc_long_txt)}<a onClick={this.handleShowMore} className="link vm_desc_less" style={{cursor:"pointer", display: "inline-block", color: "#017dc3", marginLeft: "5px"}} data-prod_id={this.props.product_id}>{_less_text}</a></>
									: <>{ReactHtmlParser(_desc_short_txt)}<a onClick={this.handleShowMore} className="link vm_desc_showmore" style={{cursor:"pointer", display: "inline-block", color: "#017dc3", marginLeft: "5px"}} data-prod_id={this.props.product_id}>{_more_text}</a></>
								}
							</>
							: <>{ReactHtmlParser(_desc_long_txt)}</>
						}
					</>
				</p>
			</div>
		)
	}
}